import React, { useEffect, useState } from 'react';

import { Avatar, Button, List, Skeleton, Card } from 'antd';
import { Icon } from '@ant-design/compatible';
import useTranslate from '@root/core/hooks/useTranslate';
import { WarehouseCardList } from '../interface';
import RowItem from './row-list/RowItem';
import wareHouseService from '@root/modules/Warehouse/Dasboard/services/warehouse';
import { Link } from 'react-router-dom';

function SellerList({ setLoading }: any) {
  const [listSell, setListSell] = useState([] as any);
  const [t] = useTranslate();

  /*------------api seller list-----*/
  const getListSeller = async () => {
    setLoading(true);
    const warehouse = await wareHouseService.getListSeller();
    setListSell(warehouse.data);
    setLoading(false);
  };

  useEffect(() => {
    getListSeller();
  }, []);

  return (
    <>
      <Card
        style={{ gap: '50px', width: '50%' }}
        className="cardList"
        type="inner"
        title="Seller list"
        extra={<Link to="/admin/inventory">More details</Link>}
      >
        {listSell?.map((item: any, index: any) => (
          <>
            {' '}
            <RowItem
              key={item.id}
              itemName={item.name}
              status="Number of Product Type"
              numPro={item.numberOfProductType}
              email={item.email}
              url="/admin/inventory"
            />
          </>
        ))}
      </Card>
    </>
  );
}

export default SellerList;
